import { render, staticRenderFns } from "./eod-events-table-compact.vue?vue&type=template&id=6b4c297f"
import script from "./eod-events-table-compact.vue?vue&type=script&lang=js"
export * from "./eod-events-table-compact.vue?vue&type=script&lang=js"
import style0 from "./eod-events-table-compact.vue?vue&type=style&index=0&id=6b4c297f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports